import { useEffect } from 'react';

import { useRelevancyFeed } from '../model';
import { useRelevancyOptions } from '../store';

export const useInfiniteScroll = (scrolled: boolean) => {
  const { loadMore } = useRelevancyFeed();
  const { options } = useRelevancyOptions();
  useEffect(() => {
    if (!options.infiniteScroll || !scrolled) return;

    loadMore();
  }, [loadMore, options.infiniteScroll, scrolled]);
};
